<template>
    <Widget :closeButton="true" :isOpen.sync="isOpen" title="Character Editor" positionHint="center">
        <fieldset>
            <legend>Name</legend>
            <input v-model="name" type="textarea" />
        </fieldset>
        <fieldset>
            <legend>Description</legend>
            <textarea v-model="description" rows="4" cols="50" />
        </fieldset>
        <button @click="save">Save</button>
        <button @click="cancel">Cancel</button>
    </Widget>
</template>

<script lang="ts">
import * as jsonpatch from 'fast-json-patch';
import _ from 'lodash';

import Widget from '@/components/common/widget/Widget';

export default {
    components: {
        Widget: Widget,
    },
    data: function() {
        return {
            isOpen: false,
            character: null,
            attributes: null,
        };
    },
    computed: {
        name: {
            get: function() {
                return this.attributes ? this.attributes.name : '';
            },
            set: function(value) {
                this.attributes.name = value;
            },
        },
        description: {
            get: function() {
                return this.attributes ? this.attributes.description : '';
            },
            set: function(value) {
                this.attributes.description = value;
            },
        },
    },
    watch: {
        character: function() {
            this.attributes = _.cloneDeep(this.character.attributes);
        },
    },
    methods: {
        save() {
            const patch = jsonpatch.compare({ attributes: this.character.attributes }, { attributes: this.attributes });
            if (patch.length > 0) {
                this.$emit('onChange', { characterId: this.character.id, patch: patch });
                this.character.attributes = this.attributes;
                this.isOpen = false;
            }
        },
        cancel() {
            this.isOpen = false;
            this.attributes = {};
            this.$emit('onCancel', {});
        },
    },
};
</script>
